import backgroundSource from 'assets/images/vxl/component/productIntroScreen/background-texture-light.png';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import HyperlinkSmText from 'shared/components/vxl/typography/primary/hyperlink/HyperlinkSmText';
import ProductIntroScreen from 'shared/patterns/vxl/ProductIntroScreen/ProductIntroScreen';
import theme from 'shared/styles/theme';

interface ReferralLimitReachedProps {
  headlineText?: string;
  limitMessage?: string;
  legalLinkText?: string;
  onTermsPress: () => void;
}

const ReferralLimitReached = ({
  headlineText,
  limitMessage,
  legalLinkText,
  onTermsPress,
}: ReferralLimitReachedProps) => {
  const { t: translatedText } = useTranslation('accounts', {
    keyPrefix: 'inviteFriends',
  });

  return (
    <ProductIntroScreen
      eyebrowText={translatedText('congratsText')}
      headlineText={headlineText ?? ''}
      headlineTextStyle="expressive"
      backgroundTexture={backgroundSource}
      visual="HIGH_FIVE_A"
      topPadding={80}
      bodyContent={
        <View style={styles.limitContainer}>
          <BodyBaseText style={styles.limitMessageText}>
            {limitMessage ?? ''}
          </BodyBaseText>
          {legalLinkText ? (
            <HyperlinkSmText
              numberOfLines={0}
              onPress={() => {
                onTermsPress();
              }}
            >
              {legalLinkText}
            </HyperlinkSmText>
          ) : null}
        </View>
      }
    />
  );
};

const styles = StyleSheet.create({
  limitContainer: {
    alignItems: 'center',
    paddingHorizontal: theme.spacing.m,
  },
  limitMessageText: {
    textAlign: 'center',
    marginBottom: theme.spacing.l,
  },
});

export default ReferralLimitReached;
